import { SofturaTable } from "client/CommonComponents";

const AdditionalApprovers = (props: any) => {
    const { additionalApprovalTableTemp, additionalApproversColumns, showGrid } = props;
    return (
        <>
            <p className="mb-2 note-text">An additional approver is required for AFE orders when the quoted amount exceeds $10,000 and the AFE Type is Fleet Equipment.</p>
            <div className={`pe-0 ${additionalApprovalTableTemp?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
                {showGrid && <SofturaTable
                    data={additionalApprovalTableTemp.current ?? []}
                    columns={additionalApproversColumns}
                    sort={false}
                    pagination={false}
                    globalSearch={false}
                    fixedHeader={true}
                    className="approvalHierarchy-grid"
                 data-attribute="AdditionalApprovers_Default_Grid" />}
            </div>
        </>
    );
}

export default AdditionalApprovers;